export * from '@src/slide/application/service/copy-paste/core/cp-image.new';
export * from '@src/slide/application/service/copy-paste/core/cp-image';
export * from '@src/slide/application/service/copy-paste/core/cp-ppt';
export { default as domtoimage } from '@src/slide/application/service/copy-paste/core/lib/dom_to_image';
